/* ============================================================
   Админка · Спонсорские заявки (из модалки «Стать спонсором»).
   Статус меняется на сервере: пока ответ не пришёл — строка
   заблокирована, при ошибке список откатывается (см. content.js).
   ============================================================ */
import { useState } from 'react';
import { useFedContent } from '../content';
import { AdmCard, StPill, AdmIconBtn, EmptyRow } from './ui';

// Статусы бэкенда (SponsorRequest.STATUSES) → кнопки перевода
const NEXT = {
  new: [['work', 'gold', 'check', 'В работу']],
  work: [['done', 'ok', 'check', 'Завершить'], ['new', null, 'inbox', 'Вернуть в новые']],
  done: [['work', 'gold', 'edit', 'Вернуть в работу']],
};

export default function AdmSponsors() {
  const sponsorRequests = useFedContent((s) => s.sponsorRequests);
  const setSponsorStatus = useFedContent((s) => s.setSponsorStatus);
  const deleteSponsorRequest = useFedContent((s) => s.deleteSponsorRequest);
  const [busyId, setBusyId] = useState(null);

  const act = async (id, fn) => {
    if (busyId) return;
    setBusyId(id);
    await fn();
    setBusyId(null);
  };

  const remove = (r) => {
    if (!window.confirm(`Удалить заявку «${r.name}»?`)) return;
    act(r.id, () => deleteSponsorRequest(r.id));
  };

  return (
    <div className="fed-admin-view">
      <AdmCard className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="fed-tbl">
            <thead>
              <tr><th>Компания / имя</th><th>Телефон</th><th>Формат</th><th>Сообщение</th><th>Статус</th><th>Действия</th></tr>
            </thead>
            <tbody>
              {sponsorRequests.map((r) => (
                <tr key={r.id} style={busyId === r.id ? { opacity: 0.5 } : undefined}>
                  <td data-wide className="font-semibold" style={{ color: 'var(--fed-fg)' }}>{r.name}</td>
                  <td data-label="Телефон" className="font-mono" style={{ fontSize: 12.5, whiteSpace: 'nowrap' }}>{r.phone}</td>
                  <td data-label="Формат"><span className="font-mono text-gold bg-surface-3 rounded-md" style={{ fontSize: 11, padding: '4px 8px' }}>{r.typeLabel || r.type}</span></td>
                  <td data-label="Сообщение" data-wide style={{ maxWidth: 280 }}>{r.message}</td>
                  <td data-label="Статус"><StPill st={r.status} label={r.status === 'done' ? 'Завершена' : undefined} /></td>
                  <td>
                    <div className="flex gap-2">
                      {(NEXT[r.status] || NEXT.new).map(([next, tint, icon, title]) => (
                        <AdmIconBtn
                          key={next}
                          name={icon}
                          tint={tint}
                          title={title}
                          onClick={() => act(r.id, () => setSponsorStatus(r.id, next))}
                        />
                      ))}
                      <AdmIconBtn name="trash" tint="danger" title="Удалить" onClick={() => remove(r)} />
                    </div>
                  </td>
                </tr>
              ))}
              {!sponsorRequests.length && <EmptyRow colSpan={6}>Спонсорских заявок нет</EmptyRow>}
            </tbody>
          </table>
        </div>
      </AdmCard>
    </div>
  );
}
